import { Trophy } from "lucide-react";

// Static mirror of backend config.FOOTBALL_POINTS — keep in sync if config changes.
const SECTIONS = [
  {
    title: "Appearance",
    rows: [
      ["Played 1–59 minutes", "+1"],
      ["Played 60+ minutes", "+2"],
    ],
  },
  {
    title: "Goals (by position)",
    rows: [
      ["Goal by Goalkeeper", "+10"],
      ["Goal by Defender", "+6"],
      ["Goal by Midfielder", "+5"],
      ["Goal by Forward", "+4"],
      ["Assist", "+3"],
    ],
  },
  {
    title: "Defensive",
    rows: [
      ["Clean sheet — GK / DEF (60+ min)", "+4"],
      ["Clean sheet — MID (60+ min)", "+1"],
      ["Every 3 saves (GK)", "+1"],
      ["Penalty saved (GK)", "+5"],
    ],
  },
  {
    title: "Negative",
    rows: [
      ["Yellow card", "-1"],
      ["Red card", "-3"],
      ["Own goal", "-2"],
      ["Penalty missed", "-2"],
    ],
  },
  {
    title: "Bonuses & Multipliers",
    rows: [
      ["Captain", "2× points"],
      ["Vice-Captain", "1.5× points"],
      ["Manager of the Day", "+5"],
    ],
  },
];

const Row = ({ label, value }) => {
  const negative = String(value).startsWith("-");
  return (
    <div className="flex items-center justify-between py-2.5 text-sm" data-testid="points-row">
      <span className="pr-3 text-muted-foreground">{label}</span>
      <span className={`shrink-0 font-extrabold ${negative ? "text-red-400" : "wc-gold"}`}>{value}</span>
    </div>
  );
};

export default function FootballPointSystemPage() {
  return (
    <div className="football-theme min-h-screen bg-background pb-12" data-testid="football-point-system-page">
      <div className="wc-hero-gradient px-4 pb-5 pt-4">
        <div className="flex items-center gap-2 text-amber-300"><Trophy size={18} /><span className="text-sm font-bold">Football World Cup 2026</span></div>
        <h1 className="mt-1 text-xl font-extrabold text-white">Point System</h1>
        <p className="mt-1 text-sm text-white/70">How your fantasy players earn points.</p>
      </div>

      <div className="mx-auto max-w-md space-y-4 px-4 pt-4">
        {SECTIONS.map((s) => (
          <div key={s.title} className="rounded-xl border border-border bg-card p-4">
            <h2 className="mb-1 text-base font-bold">{s.title}</h2>
            <div className="divide-y divide-border">
              {s.rows.map(([label, value]) => <Row key={label} label={label} value={value} />)}
            </div>
          </div>
        ))}
        <p className="px-1 pb-2 text-center text-xs text-muted-foreground">
          Captain auto-promotes: if your captain does not play, your vice-captain becomes captain (2×).
        </p>
      </div>
    </div>
  );
}
